import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import {AppRoutes} from './AppRoutes';
import {AuthProvider} from './hooks/AuthContext';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  </React.StrictMode>,
);
